import MeetingSummaryBooking from './MeetingSummaryBooking';

export default MeetingSummaryBooking;
